import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NavController } from '@ionic/angular';
import { Types } from 'src/app/constants/gift-card-type';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { PwaService } from 'src/app/services/pwa.service';
import { UiServices } from 'src/app/services/ui-services';
import { PwaAlertIosComponent } from '../pwa-alert-ios/pwa-alert-ios.component';

@Component({
  selector: 'app-pwa',
  templateUrl: './pwa.component.html',
  styleUrls: ['./pwa.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PwaComponent implements OnInit {
  @Input() data: any;

  public images: any[] = [];

  constructor(
    private paramSv: ParamServicesService,
    private navCtrl: NavController,
    private pwaSv: PwaService,
    private cdr: ChangeDetectorRef,
    private uiSv: UiServices
  ) {}

  async ngOnInit() {
    try {
      const orden =
        this.data?.type === 'contact'
          ? '6'
          : this.data.type === 'suggestion'
          ? '22'
          : '';
      const res: any[] = await this.paramSv.getImages(orden, '0');
      const image = res?.find((item) => item.name === this.data?.type);
      if (!image) return;
      this.images = image.images;
      this.cdr.detectChanges();
    } catch (err) {
      console.error(err);
    }
  }

  goTo() {
    if (this.data.type === 'pwa') {
      this.downloadPwa();
    } else if (
      this.data.type === 'bannerGiftCard' ||
      this.data.type === 'bannerCupon'
    ) {
      const isCoupon =
        this.data.type === 'bannerCupon' ? Types.COUPON : Types.GIFT_CARD;
      this.navCtrl.navigateForward(`buy-gift-cards?isCoupon=${isCoupon}`);
    } else {
      this.navCtrl.navigateForward(this.data.type);
    }
  }

  private isIosWithNoStandalone(): boolean {
    const ua = window.navigator.userAgent;
    const isIOS = /iP(ad|hone|od)/.test(ua);
    const isInStandaloneMode =
      ('standalone' in window.navigator && window.navigator['standalone']) ||
      window.matchMedia('(display-mode: standalone)').matches;
    return isIOS && !isInStandaloneMode;
  }

  async downloadPwa() {
    if (this.isIosWithNoStandalone()) {
      // Show message to user: install app to home screen for notifications
      this.uiSv.showPopover?.(PwaAlertIosComponent);
      return;
    }

    if (this.pwaSv.deferredPrompt) {
      this.pwaSv.deferredPrompt?.prompt();
      const { outcome } = await this.pwaSv.deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        this.pwaSv.backbutton = true;
        this.cdr.detectChanges();
      }
    }
  }
}
